<template>
    <section id="why-wisten" class="contain">
        <div class="inner" style=" max-width: 100%;">
            <!-- why- Top Icon -->
            <div class="contain-logo br">
                <i class="fa fa-briefcase "></i>
            </div>

            <!-- Iphone images -->
            <div class="w-iphone animated" data-animation="fadeInLeft" data-animation-delay="0">
                <img :src="baseUrl + '/new-assets/images/w-iphone.png?v=11'" alt="-iphone">
            </div>

            <!-- accordion menu -->
            <div class="accordion" id="accordion2">
                <div class="accordion-head">Useful <span> Information</span></div>

                <!-- accordion menu 1 -->
                <div class="panel">
                    <div class="accordion-heading">
                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion2" href="#coll-one">

                            <i class="fa fa-check"></i>
                            Important Deadlines
                        </a>
                    </div>
                    <div id="coll-one" class="accordion-body collapse in">
                        <div class="accordion-inner">
                            <p>High-Resolution Logo (For Presenting Companies): <b>no later than 10 July</b></p>
                            <p>Accommodation: <b>no later than 17 July </b> </p>
                            <p>Presentation (For Presenting Companies): <b>no later than 28 August</b> </p>
                        </div>
                    </div>
                </div>


                <!-- <div class="panel">
                    <div class="accordion-heading">
                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion2" href="#coll-sex">
                            <i class="fa fa-check"></i>
                            COVID-19 Regulations and Entry Requirements
                        </a>
                    </div>
                    <div id="coll-sex" class="accordion-body collapse">
                        <div class="accordion-inner">
                            Due to social distancing and regulations associated with the COVID-19 pandemic kindly note that
                            masks must be worn at all times indoors
                            yet masks are not mandatory across all outdoor spaces.
                            <br />
                            Airline policies in-line with the COVID-19 pandemic may differ and are subject to change
                            according to each country and time of travel.
                            Therefore, you will need to check with your airline ahead of your travel.

                        </div>
                    </div>
                </div> -->


                <div class="panel">
                    <div class="accordion-heading">
                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion2" href="#coll-7">
                            <i class="fa fa-check"></i>Language
                        </a>
                    </div>
                    <div id="coll-7" class="accordion-body collapse">
                        <div class="accordion-inner">
                            The official language of the meetings is English.
                        </div>
                    </div>
                </div>

                <div class="panel last">
                    <div class="accordion-heading">
                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion2" href="#coll-four">
                            <i class="fa fa-check"></i>
                            Climate
                        </a>
                    </div>
                    <div id="coll-four" class="accordion-body collapse">
                        <div class="accordion-inner">
                            Across the UK, September temperatures average a daily high of 17 degrees Celsius (62 degrees
                            Fahrenheit) and a low of 9 °C (48 °F).
                        </div>
                    </div>
                </div>

                <div class="panel">
                    <div class="accordion-heading">
                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion2" href="#coll-8">
                            <i class="fa fa-check"></i>Time Zone
                        </a>
                    </div>
                    <div id="coll-8" class="accordion-body collapse">
                        <div class="accordion-inner">
                            Dubai is four hours ahead of Greenwich Mean Time.
                        </div>
                    </div>
                </div>

                <!-- accordion menu 3 -->
                <div class="panel">
                    <div class="accordion-heading">
                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion2" href="#coll-three">
                            <i class="fa fa-check"></i>
                            Dress Code
                        </a>
                    </div>
                    <div id="coll-three" class="accordion-body collapse">
                        <div class="accordion-inner">
                            For the conference this year, kindly dress in formal attire.
                        </div>
                    </div>
                </div>

                <!-- accordion menu 4 -->
                <div class="panel">
                    <div class="accordion-heading">
                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion2" href="#coll-9">
                            <i class="fa fa-check"></i>Attractions
                        </a>
                    </div>
                    <div id="coll-9" class="accordion-body collapse">
                        <div class="accordion-inner">
                            <p><a :href="baseUrl + '/new-assets/images/London-Attractions-2023.pdf'"
                                    style="color: #afb81d">Click here</a> to
                                discover top-rated attractions and sights you can't miss in London.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </section>
</template>

<script>
export default {
    data: () => ({
        baseUrl: window.location.origin,
    }),
}
</script>

<style lang="scss" scoped>
.animated {
    visibility: visible;
}
</style>